import { render } from "./AppfrontPermission.vue?vue&type=template&id=39b31082&scoped=true"
import script from "./AppfrontPermission.vue?vue&type=script&lang=js"
export * from "./AppfrontPermission.vue?vue&type=script&lang=js"

import "./AppfrontPermission.vue?vue&type=style&index=0&id=39b31082&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/duanju-overseas_admin_vue_live/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39b31082"]])

export default __exports__